// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var JsxRuntime = require("react/jsx-runtime");
var TicketCategory$ReactHooksTemplate = require("../tickets/ticketCategory.res.js");

function TicketCategoryForm(props) {
  var toggleModal = props.toggleModal;
  var onFormSubmit = props.onFormSubmit;
  var selectedTicketCategory = props.selectedTicketCategory;
  var match = React.useState(function (param) {
        return selectedTicketCategory;
      });
  var setTicketCategory = match[1];
  var ticketCategory = match[0];
  var handleNameChange = function ($$event) {
    var name = $$event.target.value;
    Curry._1(setTicketCategory, (function (param) {
            return TicketCategory$ReactHooksTemplate.setName(ticketCategory, name);
          }));
  };
  var handleDescriptionChange = function ($$event) {
    var description = $$event.target.value;
    Curry._1(setTicketCategory, (function (param) {
            return TicketCategory$ReactHooksTemplate.setDescription(ticketCategory, description);
          }));
  };
  var handlePriorityChange = function ($$event) {
    var priority = $$event.target.value;
    Curry._1(setTicketCategory, (function (param) {
            return TicketCategory$ReactHooksTemplate.setPriority(ticketCategory, priority);
          }));
  };
  var description = TicketCategory$ReactHooksTemplate.description(ticketCategory);
  var p = ticketCategory.priority;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Name",
                                      className: "block text-sm font-medium text-gray-700 mb-2"
                                    }),
                                JsxRuntime.jsx("input", {
                                      className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                                        TicketCategory$ReactHooksTemplate.name(ticketCategory).length === 0 ? "border-red-300" : "border-gray-300"
                                      ),
                                      maxLength: 100,
                                      placeholder: "Enter category name",
                                      type: "text",
                                      value: TicketCategory$ReactHooksTemplate.name(ticketCategory),
                                      onChange: handleNameChange
                                    }),
                                TicketCategory$ReactHooksTemplate.name(ticketCategory).length === 0 ? JsxRuntime.jsx("p", {
                                        children: "Name can't be empty",
                                        className: "mt-1 text-xs text-red-600"
                                      }) : null
                              ]
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Description",
                                      className: "block text-sm font-medium text-gray-700 mb-2"
                                    }),
                                JsxRuntime.jsx("textarea", {
                                      className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none",
                                      maxLength: 100,
                                      placeholder: "Enter category description (optional)",
                                      rows: 3,
                                      value: description !== undefined ? description : "",
                                      onChange: handleDescriptionChange
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Priority",
                                      className: "block text-sm font-medium text-gray-700 mb-2"
                                    }),
                                JsxRuntime.jsx("input", {
                                      className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                                      min: "1",
                                      placeholder: "Set priority level",
                                      step: 1.0,
                                      type: "number",
                                      value: p !== undefined ? String(p) : "1",
                                      onChange: handlePriorityChange
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Higher numbers indicate higher priority",
                                      className: "mt-1 text-xs text-gray-500"
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Color",
                                      className: "block text-sm font-medium text-gray-700 mb-3"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: $$Array.of_list(List.map((function (color) {
                                                  return JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("div", {
                                                                      className: "w-12 h-12 rounded-lg shadow-sm transition-all duration-200 " + (
                                                                        ticketCategory.color === color ? "ring-2 ring-blue-500 ring-offset-2 scale-110" : "hover:scale-105"
                                                                      ),
                                                                      style: {
                                                                        backgroundColor: TicketCategory$ReactHooksTemplate.colorToString(color)
                                                                      }
                                                                    }),
                                                                JsxRuntime.jsx("span", {
                                                                      children: TicketCategory$ReactHooksTemplate.colorToName(color),
                                                                      className: "text-xs mt-2 transition-colors duration-200 " + (
                                                                        ticketCategory.color === color ? "text-blue-600 font-medium" : "text-gray-600"
                                                                      )
                                                                    })
                                                              ],
                                                              className: "flex flex-col items-center cursor-pointer group",
                                                              onClick: (function (param) {
                                                                  Curry._1(setTicketCategory, (function (param) {
                                                                          return TicketCategory$ReactHooksTemplate.setColor(ticketCategory, color);
                                                                        }));
                                                                })
                                                            }, TicketCategory$ReactHooksTemplate.colorToString(color));
                                                }), TicketCategory$ReactHooksTemplate.allColors)),
                                      className: "grid grid-cols-4 gap-4"
                                    })
                              ]
                            })
                      ],
                      className: "p-6 space-y-6"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Cancel",
                              className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                              onClick: (function (param) {
                                  Curry._1(toggleModal, undefined);
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Save Category",
                              className: "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                                TicketCategory$ReactHooksTemplate.name(ticketCategory).length === 0 ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                              ),
                              disabled: TicketCategory$ReactHooksTemplate.name(ticketCategory).length === 0,
                              onClick: (function (param) {
                                  Curry._1(onFormSubmit, ticketCategory);
                                })
                            })
                      ],
                      className: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end space-x-3"
                    })
              ],
              className: "flex flex-col"
            });
}

var make = TicketCategoryForm;

exports.make = make;
/* react Not a pure module */
